import { trimLeadingSlash, trimTrailingSlash } from './trimSlash';

export const combinePath = (parentPath: string, childPath: string) =>
  `${trimTrailingSlash(parentPath)}/${trimLeadingSlash(childPath)}`;
